import styled from 'styled-components'

import { Counter } from '~/components/counter'
import theme from '~/truck/theme'

export const CounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50%;
  position: relative;
`

export const StyledCounterError = styled(Counter.Error)`
  bottom: ${theme.spacing.compact * -5}px;
  position: absolute;
`
